export const AUDIT_KIND_CHIPS = [
    {
        key: 'request',
        label: 'Request',
        kinds: ['service_request', 'staff_request'],
    },
    { key: 'message', label: 'Message', kinds: ['message'] },
    { key: 'call', label: 'Call', kinds: ['call'] },
    { key: 'note', label: 'Note', kinds: ['note'] },
    {
        key: 'inspection',
        label: 'Inspection',
        kinds: ['inspection', 'move_in_inspection'],
    },
    { key: 'work', label: 'Workorder', kinds: ['workorder'] },
    { key: 'offer', label: 'Offer', kinds: ['offer'] },
    { key: 'signing', label: 'Signing', kinds: ['signing'] },
    { key: 'damage', label: 'Damage', kinds: ['damage'] },
    { key: 'incident', label: 'Incident', kinds: ['incident'] },
    { key: 'pet', label: 'Pet', kinds: ['pet'] },
] as const

export type AuditKindChipKey = typeof AUDIT_KIND_CHIPS[number]['key']

export const KIND_LABEL: Record<string, string> = {
    lease: 'Lease',
    service_request: 'Request',
    staff_request: 'Staff request',
    inspection: 'Inspection',
    move_in_inspection: 'Move-in',
    workorder: 'Workorder',
    lead_created: 'Lead',
    guest_card: 'Guest card',
    occupancy: 'Occupancy',
    tour: 'Tour',
    screening: 'Screening',
    application: 'Application',
    offer: 'Offer',
    signing: 'Signing',
    account: 'Account',
    call: 'Call',
    note: 'Note',
    message: 'Message',
    damage: 'Damage',
    incident: 'Incident',
    pet: 'Pet',
}

export const LEASING_KINDS = new Set([
    'lead_created',
    'guest_card',
    'occupancy',
    'application',
    'tour',
    'screening',
    'offer',
    'signing',
    'account',
])

export const REQUEST_KINDS = new Set(['service_request', 'staff_request'])

export const kindLabel = (kind: string) => KIND_LABEL[kind] || kind

export const parseKindKeys = (raw: string | null): AuditKindChipKey[] => {
    if (!raw) return []
    const valid = new Set(AUDIT_KIND_CHIPS.map((chip) => chip.key))
    return raw
        .split(',')
        .map((part) => part.trim())
        .filter((part): part is AuditKindChipKey =>
            valid.has(part as AuditKindChipKey),
        )
}

export const serializeKindKeys = (keys: AuditKindChipKey[]): string | null =>
    keys.length > 0 ? keys.join(',') : null

export const serializeAuditExportKinds = (keys: AuditKindChipKey[]) =>
    serializeKindKeys(
        keys.length > 0 ? keys : AUDIT_KIND_CHIPS.map((chip) => chip.key),
    )

export const eventMatchesKindKeys = (
    kind: string,
    selected: AuditKindChipKey[],
) => {
    if (selected.length === 0) return true
    return AUDIT_KIND_CHIPS.some(
        (chip) =>
            selected.includes(chip.key) &&
            (chip.kinds as readonly string[]).includes(kind),
    )
}
